import React, { useState, useEffect } from "react";
import DashNav from "../../../Components/DashNav/DashNav";
import "../Dashboard.css";
import "./DashPanel.css";
import "animate.css";
import { MdElectricBolt } from "react-icons/md";

function Dashboard() {
  const [userinfo, setuserinfo] = useState([]);
  const divData = [
    {
      amount: 15980,
      txt: "Total of articals sold",
    },
  ];
  for (let i = 1; i < 3; i++) {
    let obj = {
      amount: 15980,
      txt: "Total of articals sold",
    };
    divData.push(obj);
  }
  useEffect(() => {
    setuserinfo(divData);
  }, []);
  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav />
        </div>

        <div className="dashPanel mainDashPanel">
          <div className="md-mainContent animate__animated animate__zoomIn">
            <div className="md-graph">
              <span style={{ fontSize: "xx-large", marginBottom: "10px" }}>
                Welcome to iHart Dashboard
              </span>
              <span style={{ fontSize: "large" }}>
                Created By DSME Global Links
              </span>
            </div>
            {/* <div>
              <div className="md-infoDiv">
                {userinfo.map((data) => (
                  <Div data={data} />
                ))}
              </div>
            </div> */}
          </div>
          {/* <div className="md-sideContent">
            <div style={{ textAlign: "center" }}>
              <div className="md-side-text">Revenue</div>
              <div className="mds-revDiv">
                <div className="revDiv">
                  <div className="md-divIcon">
                    <MdElectricBolt fill="white" />
                  </div>
                  <i>
                    <div className="md-divTotal">Total</div>
                    <div className="md-divNumb">345k</div>
                  </i>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
const Div = ({ data }) => {
  return (
    <>
      <div className="divInfo">
        <div className="divInfo-amount">{data.amount}</div>
        <div className="divInfo-txt">{data.txt}</div>
      </div>
    </>
  );
};

export default Dashboard;
